// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
  display: flex;
  gap: 4px;
  padding: 8px 12px;
  background: var(--button-background);
  border-bottom: 1px solid var(--light-border);
  flex-shrink: 0;
}

.tabsButton {
  padding: 8px 15px;
  border: none;
  border-radius: var(--button-border-radius);
  background: var(--button-background);
  color: var(--button-color);
  font-family: inherit;
  font-weight: 500;
  cursor: pointer;
  opacity: var(--button-opacity);
  font-size: var(--font-size-small);
}

.tabsButton:hover {
  opacity: 1;
}

.tabsButton:disabled {
  cursor: default;
  opacity: 0.45;
}

.tabsButton:disabled:hover {
  opacity: 0.45;
}

.tabsButton:focus {
  outline: var(--outline-focus);
}

.tabsButton:active {
  outline: var(--outline-active);
}

.tabsButton-active {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
  opacity: 1;
}

.tabPanels {
  flex: 1 1 auto;
  min-height: 0;
}

.tabPanel {
  display: none;
}

.tabPanelActive {
  display: block;
  height: 100%;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Tabs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,0CAA0C;EAC1C,oCAAoC;EACpC,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".tabs {\n  display: flex;\n  gap: 4px;\n  padding: 8px 12px;\n  background: var(--button-background);\n  border-bottom: 1px solid var(--light-border);\n  flex-shrink: 0;\n}\n\n.tabsButton {\n  padding: 8px 15px;\n  border: none;\n  border-radius: var(--button-border-radius);\n  background: var(--button-background);\n  color: var(--button-color);\n  font-family: inherit;\n  font-weight: 500;\n  cursor: pointer;\n  opacity: var(--button-opacity);\n  font-size: var(--font-size-small);\n}\n\n.tabsButton:hover {\n  opacity: 1;\n}\n\n.tabsButton:disabled {\n  cursor: default;\n  opacity: 0.45;\n}\n\n.tabsButton:disabled:hover {\n  opacity: 0.45;\n}\n\n.tabsButton:focus {\n  outline: var(--outline-focus);\n}\n\n.tabsButton:active {\n  outline: var(--outline-active);\n}\n\n.tabsButton-active {\n  background: var(--primary-color);\n  border-color: var(--primary-color);\n  color: #fff;\n  opacity: 1;\n}\n\n.tabPanels {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.tabPanel {\n  display: none;\n}\n\n.tabPanelActive {\n  display: block;\n  height: 100%;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
